/** @deprecated - Use ~/domains/common/components/Modal/ConfirmModalV2 instead */
import { Group, Loader, Stack } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import dt from '~/testing';
import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import Modal from '../Modal/Modal';

import useStyles from './ConfirmModal.styles';
import ConfirmModalSkeleton from './ConfirmModalSkeleton';

type ConfirmModalProps = {
  cancelText?: string;
  confirmText?: string;
  description?: string;
  isLoading?: boolean;
  isOnConfirmLoading?: boolean;
  isOpen: boolean;
  onCancel?: () => void;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
};

export function ConfirmModal({
  cancelText,
  confirmText,
  description,
  isLoading = false,
  isOnConfirmLoading = false,
  isOpen,
  onCancel,
  onClose,
  onConfirm,
  title,
}: ConfirmModalProps) {
  const { t } = useTranslation('common');
  const { classes, theme } = useStyles();
  const isMobile = useIsMobile();

  const confirmLabel = confirmText || t('modal.confirm');
  const cancelLabel = cancelText || t('modal.cancel');

  return (
    <Modal isOpened={isOpen} onClose={onClose}>
      {isLoading && <ConfirmModalSkeleton />}
      {!isLoading && (
        <Stack spacing={theme.other.spacing._8} pt={isMobile ? theme.other.spacing._16 : 0}>
          {title && (
            <Title tag="h3" variant="headline-large">
              {title}
            </Title>
          )}
          {description && <Text variant="body-large">{description}</Text>}
          <Group spacing={theme.other.spacing._8} pt={theme.other.spacing._16} position="right">
            {onConfirm && (
              <Button
                className={classes.button}
                variant="primary-fill"
                size="medium"
                type="button"
                onClick={() => {
                  onConfirm?.();
                }}
                data-test-id={dt.common.components.modal.confirmModal.confirmButton}
              >
                {isOnConfirmLoading && (
                  <Loader stroke={theme.white} size="sm" style={{ verticalAlign: 'bottom' }} />
                )}
                {!isOnConfirmLoading && confirmLabel}
              </Button>
            )}
            <Button
              variant="secondary-stroke"
              size="medium"
              className={classes.button}
              onClick={() => {
                onCancel?.();
                onClose();
              }}
              data-test-id={dt.common.components.modal.confirmModal.cancelButton}
            >
              {cancelLabel}
            </Button>
          </Group>
        </Stack>
      )}
    </Modal>
  );
}
